<template>
    <div class="tile">
        <el-card :body-style="{ padding: '0px', width: '250px' }"
                 shadow="hover">
            <el-tooltip class="item"
                        effect="dark"
                        :content="product.name"
                        placement="top-start">
                <div slot="" class="tile--header">
                    <span class="text-styling"><b>{{product.name}}</b></span>
                    <div>
                        <el-tag>
                            {{ product.supplier }}
                        </el-tag>
                    </div>
                </div>
            </el-tooltip>
            <img :src="imgPath.img"
                 alt="aucune image disponible"
                 class="image">
            <div style="padding: 10px;">
                <div class="bottom clearfix flexbox-row">
                    <el-input-number v-model="num"
                                     @change="change_quantity_number(product, num)"
                                     :min="0"
                                     :max="999"
                                     placeholder="quantité"
                                     size="mini"></el-input-number>
                    <el-tag type="info"
                            effect="plain">
                        {{ product.packaging }}
                    </el-tag>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    import { cssUtils } from '../../../utils/utils';

    export default {
        props: {
            product: {},
        },
        data() {
            return {
                num: this.item_quantity(this.product),
            };
        },
        created() {
        },
        computed: {
            cart() {
                return this.$store.getters['cart/cart'];
            },
            imgPath() {
                if (this.product.pic) {
                    return {
                        ...this.product,
                        img: this.product.pic,
                    };
                }
                return {
                    ...this.product,
                    // eslint-disable-next-line global-require,import/no-dynamic-require
                    img: require('@/assets/img/noimg.png'),
                };
            },
        },
        methods: {
            item_quantity(product) {
                const quantity = this.$store.getters['cart/cart'].find((item) => item.id === product.id);
                return quantity ? quantity.quantity : 0;
            },
            change_quantity_number(product, quantityAdded) {
                const payload = {
                    quantityAdded,
                    product,
                };
                this.$store.dispatch('cart/addGivenQuantityOfAProduct', payload);
            },
            getSupplierBgColor(supplier) {
                return cssUtils.supplierBackgroundColor(supplier);
            },
        },
    };
</script>

<style lang="stylus">
    @import '~@/assets/css/main.styl';

    .text-styling {
        padding-left 5px
        padding-right 5px
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .tile {
        margin-top: 50px;
    }

    .tile--header {
        width 90%
        display flex
        flex-direction row
        justify-content space-between
        align-content center
        align-items center
        padding-top 10px
        padding-bottom 10px
    }

    .button {
        padding: 0;
        float: right;
    }

    .flexbox-row {
        display flex
        flex-direction row
        justify-content space-between
        align-items center
    }

    .image {
        width 100%
        height 220px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
